export type CalculatorType =
  | 'FLOOR'
  | 'WALL'
  | 'CEILING'
  | 'FACADE'
  | 'PARTITION'
  | 'LINEAR_SIMPLE'
  | 'LINEAR_PERIMETER'
  | 'VOLUME';

export const ITEM_CALCULATOR_MAP: Record<string, CalculatorType> = {

  // ── FLOOR — longueur × largeur ─────────────────────────────────────────────

  // demolition
  'elementstoremove_sols':              'FLOOR',
  'decaissement_leger':                 'FLOOR',
  'decaissement_profond':               'FLOOR',
  'decaissement_radier':                'FLOOR',
  'decaissement_etancheite':            'FLOOR',

  // gros-oeuvre
  'correctionplanchers_reagreage_fibre':   'FLOOR',
  'correctionplanchers_reagreage_epais':   'FLOOR',
  'correctionplanchers_billesfermacell':   'FLOOR',
  'correctionplanchers_billesosb':         'FLOOR',
  'correctionplanchers_poncageabime':      'FLOOR',
  'correctionplanchers_poncagecorrect':    'FLOOR',
  'foundation_dallebeton_standard':        'FLOOR',
  'foundation_dallebeton_armee':           'FLOOR',

  // isolation — planchers bas
  'planchersbas_terreplein_polyurethane':  'FLOOR',
  'planchersbas_terreplein_polystyrene':   'FLOOR',
  'planchersbas_videsanitaire_projection': 'FLOOR',
  'planchersbas_videsanitaire_panneaux':   'FLOOR',

  // isolation — toit-terrasse plat
  'etancheitetoiture_toitterrasse_epdm':   'FLOOR',
  'etancheitetoiture_toitterrasse_bitume': 'FLOOR',
  'etancheitetoiture_toitterrasse_pvc':    'FLOOR',

  // exterieurs — terrasses et aménagements
  'toituresexterieures_terrasse':          'FLOOR',
  'toituresexterieures_pergola':           'FLOOR',
  'amenagements_terrassecarrelage':        'FLOOR',
  'amenagements_terrassebeton':            'FLOOR',
  'amenagements_terrassebois':             'FLOOR',
  'amenagements_alleepaves':               'FLOOR',
  'espacesverts_pelouse':                  'FLOOR',
  'espacesverts_plantations':              'FLOOR',
  'espacesverts_massifs':                  'FLOOR',
  'espacesverts_arrosageauto':             'FLOOR',

  // revetements — sols
  'revetementssols_carrelage':                      'FLOOR',
  'revetementssols_carrelage_30x60':                'FLOOR',
  'revetementssols_parquetmassif':                  'FLOOR',
  'revetementssols_poncageparquet':                 'FLOOR',
  'revetementssols_parquetstratifie':               'FLOOR',
  'revetementssols_moquette':                       'FLOOR',
  'revetementssols_vinyle':                         'FLOOR',
  'revetementssols_vinyle_colle_standard':          'FLOOR',
  'revetementssols_vinyle_colle_texture_phonique':  'FLOOR',
  'amenagements_solchauffant':                      'FLOOR',
  'amenagements_solchauffant_hydraulique':          'FLOOR',
  'revetementssols_parquetmassif_colle':            'FLOOR',
  'amenagements_allee_beton':                       'FLOOR',
  'amenagements_allee_gravier':                     'FLOOR',
  'amenagements_antiderapant':                      'FLOOR',
  'revetementssols_beton_cire':                     'FLOOR',
  'revetementssols_resine_epoxy':                   'FLOOR',
  'revetementssols_resine_decorative':              'FLOOR',
  'revetementssols_beton_poli':                     'FLOOR',
  'revetementssols_microbeton':                     'FLOOR',

  // sanitaire
  'carrelage_sol':                         'FLOOR',

  // preparation
  'traitements_termites_curatif':          'FLOOR',
  'traitements_termites_preventif':        'FLOOR',

  // finitions
  'nettoyage_nettoyagesols':               'FLOOR',
  'nettoyage_depoussierage':               'FLOOR',

  // vrd
  'terrassement_parking':                  'FLOOR',
  'divers_trottoirs':                      'FLOOR',

  // cloisons
  'amenagements_mezzanine':                'FLOOR',

  // ── WALL — périmètre × hauteur − ouvertures ───────────────────────────────

  // isolation — ITI (intérieur)
  'mursexterieurs_iti_lainedeverre':       'WALL',
  'mursexterieurs_iti_lainedeveerre_hydro':'WALL',
  'mursexterieurs_iti_fibredebois':        'WALL',

  // revetements — murs intérieurs
  'preparationsupports_ratissagemurs':     'WALL',
  'preparationsupports_ratissageplaconeufs':'WALL',
  'revetementsmuraux_peinture':            'WALL',
  'revetementsmuraux_papierpeint':         'WALL',
  'revetementsmuraux_enduitdecoratif':     'WALL',
  'revetementsmuraux_carrelagemural':      'WALL',
  'revetementsmuraux_beton_cire':          'WALL',

  // sanitaire
  'carrelage_mural':                       'WALL',

  // ── CEILING — longueur × largeur (= surface au sol de la pièce) ──────────

  // demolition
  'elementstoremove_fauxplafonds':         'CEILING',

  // cloisons
  'fauxplafonds_placosuspendu':            'CEILING',
  'fauxplafonds_placophonique':            'CEILING',

  // isolation — combles perdus (surface plancher combles = surface sol)
  'combles_soufflage_lainedeverre':        'CEILING',
  'combles_soufflage_ouate':              'CEILING',
  'combles_rouleaux_lainedeverre':         'CEILING',

  // revetements — plafonds
  'preparationsupports_ratissageplafonds': 'CEILING',
  'revetementsmuraux_peintureplafond':     'CEILING',
  'revetementsmuraux_peintureplafondhaut': 'CEILING',

  // ── FACADE — somme des faces × hauteur − ouvertures ──────────────────────

  // exterieurs
  'facades_nettoyage':                     'FACADE',
  'facades_ravalement':                    'FACADE',
  'facades_peinture_hydrofuge':            'FACADE',
  'facades_ravalement_pierre':             'FACADE',
  'facades_enduit_chaux':                  'FACADE',

  // isolation — ITE (extérieur)
  'mursexterieurs_ite_polystyrene':        'FACADE',
  'mursexterieurs_ite_polystyrene_r4':     'FACADE',
  'mursexterieurs_ite_laineroche':         'FACADE',
  'mursexterieurs_ite_fibreboisbardage':   'FACADE',

  // ── PARTITION — longueur × hauteur ───────────────────────────────────────

  // demolition
  'elementstoremove_cloisons':             'PARTITION',

  // cloisons
  'cloisons_placoplatre':                  'PARTITION',
  'cloisons_betoncellulaire':              'PARTITION',
  'cloisons_briques':                      'PARTITION',
  'amenagements_cloisonsmobiles':          'PARTITION',
  'amenagements_verriere':                 'PARTITION',

  // gros-oeuvre — murs maçonnerie
  'masonry_creationmurs_parpaings':        'PARTITION',
  'masonry_creationmurs_briques':          'PARTITION',
  'masonry_creationmurs_beton':            'PARTITION',
  'masonry_renforcementmurs_injection':    'PARTITION',

  // isolation — cloisons intérieures
  'cloisonsinterieures_volumenonchauffe':  'PARTITION',
  'cloisonsinterieures_acoustique_standard':  'PARTITION',
  'cloisonsinterieures_acoustique_renforcee': 'PARTITION',

  // ── LINEAR_SIMPLE — longueur seule, sans option périmètre ───────────────
  // Murs porteurs, réseaux, clôtures, garde-corps, structures linéaires

  // demolition
  'decaissement_enduit':                          'LINEAR_SIMPLE',
  'demolitionlourde_mursporteurs':                'LINEAR_SIMPLE',

  // exterieurs
  'facades_reparationfissures':                   'LINEAR_SIMPLE',
  'clotures_bois':                                'LINEAR_SIMPLE',
  'clotures_metal':                               'LINEAR_SIMPLE',
  'clotures_pvc':                                 'LINEAR_SIMPLE',

  // finitions
  'menuiseriesdetails_retouchepeinture':          'LINEAR_SIMPLE',

  // gros-oeuvre
  'masonry_reparationmurs_fissures':              'LINEAR_SIMPLE',
  'masonry_renforcementmurs_ipn':                 'LINEAR_SIMPLE',
  'masonry_renforcementpoutres_metallique':       'LINEAR_SIMPLE',
  'masonry_renforcementpoutres_composite':        'LINEAR_SIMPLE',
  'correctionplanchers_solives_remplacement':     'LINEAR_SIMPLE',
  'correctionplanchers_solives_renforcemenent':   'LINEAR_SIMPLE',
  'foundation_renforcement_micropieux':           'LINEAR_SIMPLE',
  'foundation_renforcement_sousoeuvre':           'LINEAR_SIMPLE',
  'foundation_miseaniveau':                       'LINEAR_SIMPLE',
  'otherworks_reparationfissures_structurelles':  'LINEAR_SIMPLE',
  'otherworks_reparationfissures_injection':      'LINEAR_SIMPLE',
  'otherworks_gouttieresacier':                   'LINEAR_SIMPLE',
  'otherworks_gouttierespvc':                     'LINEAR_SIMPLE',
  'otherworks_gouttierescuivre':                  'LINEAR_SIMPLE',
  'stairs_gardecorps_interieur':                  'LINEAR_SIMPLE',

  // isolation
  'etancheiteair_calfeutrage':                    'LINEAR_SIMPLE',

  // menuiserie
  'menuiseriesinterieures_placard_coulissant':    'LINEAR_SIMPLE',
  'menuiseriesinterieures_dressing_surmesure':    'LINEAR_SIMPLE',
  'serrurerie_gardecorps_acier':                  'LINEAR_SIMPLE',
  'serrurerie_gardecorps_verre':                  'LINEAR_SIMPLE',

  // preparation
  'traitements_humidite_injection':               'LINEAR_SIMPLE',
  'traitements_humidite_drainage':                'LINEAR_SIMPLE',

  // technique
  'plomberie_reseauxalimentation':                'LINEAR_SIMPLE',
  'plomberie_reseauxevacuation':                  'LINEAR_SIMPLE',

  // vrd
  'raccordements_eaupotable':                     'LINEAR_SIMPLE',
  'raccordements_electricite':                    'LINEAR_SIMPLE',
  'raccordements_gaz':                            'LINEAR_SIMPLE',
  'raccordements_assainissement':                 'LINEAR_SIMPLE',
  'terrassement_cheminacces':                     'LINEAR_SIMPLE',
  'eauxpluviales_drains':                         'LINEAR_SIMPLE',
  'eauxpluviales_trancheeinfiltration':           'LINEAR_SIMPLE',
  'divers_bordures':                              'LINEAR_SIMPLE',

  // ── LINEAR_PERIMETER — longueur + option périmètre de pièce ─────────────
  // Plinthes, moulures : se mesurent naturellement sur le tour d'une pièce

  // revetements
  'plinthes_bois':                                'LINEAR_PERIMETER',
  'plinthes_pvc':                                 'LINEAR_PERIMETER',
  'plinthes_carrelage':                           'LINEAR_PERIMETER',

  // sanitaire
  'carrelage_plinthes':                           'LINEAR_PERIMETER',

  // finitions
  'menuiseriesdetails_mouluresdecoratives':       'LINEAR_PERIMETER',

  // ── VOLUME — longueur × largeur × profondeur (m³) ────────────────────────

  // demolition
  'evacuation_inertes':                           'VOLUME',
  'evacuation_dangereux':                         'VOLUME',

  // finitions
  'nettoyage_enlevementgravats':                  'VOLUME',

  // vrd
  'terrassement_fouilles':                        'VOLUME',
};
